import { Editor } from "@knowt/editor/core";
import { Node } from "@knowt/editor/pm/model";

export const findNodeById = (editor: Editor, id: string) => {
    let foundNode = null as {
        node: Node;
        pos: number;
        start: number;
        end: number;
    } | null;

    editor.state.doc.descendants((node, pos) => {
        if (node.attrs?.id === id) {
            foundNode = {
                node,
                pos,
                start: pos,
                end: pos + node.nodeSize,
            };
            return false;
        }
    });

    return foundNode;
};
